import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-compass-3-line text-background-50 text-sm"></i>
              </div>
              <span className="text-lg font-semibold text-foreground-950">91浏览器</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              极速浏览，隐私保护，多端同步。91浏览器致力于为您提供安全、流畅、高效的上网体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">文章分类</h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">首页</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">关于我们</Link></li>
              <li><a href="#" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">下载中心</a></li>
              <li><a href="#" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">帮助中心</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">联系我们</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-mail-line text-primary-500"></i>
                support@91browser.com
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-phone-line text-primary-500"></i>
                400-888-9191
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-map-pin-line text-primary-500"></i>
                北京市海淀区中关村科技园
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-200/70 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 91浏览器. 保留所有权利.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">用户协议</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">Cookie设置</a>
          </div>
        </div>
      </div>
    </footer>
  );
}